<template>
    <el-dialog title="代理商编辑" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">

        <el-form :model="form" :rules="rules" ref="form">

            <el-form-item label="商务名称" :label-width="formLabelWidth" prop="bizPersonnelName" >
                <el-input 
                    v-model="form.bizPersonnelName" 
                    autocomplete="off" placeholder="请输入商务名称"
                    style="width: 240px"
                ></el-input>
            </el-form-item>

            <el-form-item label="提成点位" :label-width="formLabelWidth" prop="bizRate">
                <el-col>
                <el-input
                    v-model="form.bizRate"
                    placeholder="提成点位"
                    style="width: 240px"
                ><template slot="append">%</template></el-input>
                </el-col>
                <br>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="saveMerchant">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "SystemEdit",
        props: {
            show: Boolean,
            formData: Object,
            action: String,
        },

        created(){
        },
        data(){
            return {
                dialogShow: this.show,
                form: {
                    bizPersonnelName: '',
                    bizRate:'',
                },
                agentList:[],
                formLabelWidth: '120px',
                rules: {
                    bizRate: [
                        {required: true, message: '请输入提成点位', trigger: 'blur'},
                        {min: 1, max: 4, message: '请输入1到4个数字', trigger: 'blur'}
                    ],
                    bizPersonnelName:[
                        {required: true, message: '请输入代理商登陆账号', trigger: 'blur'},
                        {min: 6, max: 20, message: '请输入6到20个字母和数字', trigger: 'blur'}
                    ]
                }
            }
        },
        methods:{
            openDialog() {
            },
            closeDialog() {
                this.dialogShow = false;
                this.$refs['form'].resetFields(); //关闭的时候重置表单
                this.$emit('update:show', false);
            },

            saveMerchant(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.axios.post("/bizSettlement/addBizPersonnel", this.form).then(res => {
                            if (res.code === 200) {

                                this.$notify({
                                    title: '添加成功',
                                    message: res.msg,
                                    type: 'success'
                                });

                                this.$bus.$emit('refresh'); //通知刷新
                                this.closeDialog();
                            } else {

                                this.$notify.error({
                                    title: '添加失败',
                                    message: res.msg,
                                });
                            }
                        })
                    } else {
                        return false;
                    }
                });

            }
        },
        watch: {
            show(newVal) {
                this.dialogShow = newVal;
            }
        },
    }
</script>

<style scoped>

</style>